import { PanelVarsForPassengerOutput } from '@allocab/allocab-passenger-shared-types';
import { getPanelNameLabelByKey } from '@allocab/allocab-shared-utils';

import berlineImage from '../../assets/images/panel-row/berline.png';
import businessImage from '../../assets/images/panel-row/business.png';
import greenImage from '../../assets/images/panel-row/green.png';
import motoImage from '../../assets/images/panel-row/moto.png';
import taxiImage from '../../assets/images/panel-row/taxi.png';
import vanAccessImage from '../../assets/images/panel-row/van-access.png';
import vanImage from '../../assets/images/panel-row/van.png';
import vaoImage from '../../assets/images/panel-row/vao.png';
import { assertNever } from '../../utils/common';

interface Props {
  panelVars: PanelVarsForPassengerOutput;
}
export const PanelImage = ({ panelVars }: Props) => {
  switch (panelVars.key) {
    case 'BERLINE':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={greenImage} />;
    case 'BUSINESS':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={businessImage} />;
    case 'VAO':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={vaoImage} />;
    case 'VAN':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={vanImage} />;
    case 'COVTC':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={greenImage} />;
    case 'MOTO':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={motoImage} />;
    case 'GREEN':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={greenImage} />;
    case 'TAXI':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={taxiImage} />;
    case 'TAXI_VAN':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={taxiImage} />;
    case 'TAXI_CONV':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={taxiImage} />;
    case 'ACCESS':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={vanAccessImage} />;
    case 'VAN_ACCESS':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={vanAccessImage} />;
    case 'AMBULANCE':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={berlineImage} />;
    case 'UNKNOWN':
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={greenImage} />;
    default:
      assertNever(panelVars.key, '[PanelImage] type unknown');
      return <img className="w-14" alt={getPanelNameLabelByKey(panelVars.key)} src={greenImage} />;
  }
};
